import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AppState } from "../../../store";
import React, { useEffect, useMemo } from "react";
import { resetAgentForm } from "../store/agent-form.slice";
import PageHeader from "../../shared-components/page-header/PageHeader";
import { useTranslation } from "react-i18next";
import AgentSearchPanel from "./search-panel/AgentSearchPanel";
import LoadingForm from "../../shared-components/loading-form/LoadingForm";
import AgentPaymentTable from "./agent-table/AgentPaymentTable";
import { toggleQuickPanel } from "../../shared-components/quick-panel/store";
import { fetchAllPayments } from "../store/payment-list.slice";
import { clearFilterPayments } from "../store/filter-payment.slice";
import useAuthority from "../../../hooks/useAuthority";
import { ROLES } from "../../../constants/roles";
import {filterPayments} from "../store/filter-payment.slice";
export interface PaymentListType {
  currencyResponse: {
    id: string;
    isoCode: string;
    name: string;
    symbol: string;
  };
}

const AgentPaymentGeneric = (props: PaymentListType) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const history = useHistory();
  const { params }: any = useRouteMatch();
  const account = useSelector((state: AppState) => state.account.account);
  const currentAccount = account?.account;
  const { hasUserAnyAuthority } = useAuthority();

  const isAdmin = hasUserAnyAuthority([ROLES.ROLE_ADMIN]);
  const isAgent = hasUserAnyAuthority([ROLES.ROLE_AGENT]) && !isAdmin;

  const agentLoading = useSelector(
    (state: AppState) => state.agents.agent.loading
  );

  const agentForm = useSelector((state: AppState) => state.agents.agentForm);

  const { paymentList, loading } = useSelector(
    (state: AppState) => state.agents.paymentList
  );

  const filterPayment = useSelector(
    (state: AppState) => state.agents.filterPayment
  );

  const balances = useSelector(
    (state: AppState) => state.agents.agent.agent?.balances
  );

  const currentBalance = balances?.find(
    (balance) => balance.currencyResponse.id === params.currencyId
  );

// const filterPayment = useSelector(
//   (state: AppState) => state.agents.filterPayment
// );

const filteredPaymentList = useMemo((): typeof paymentList => {
  if (!paymentList) {
    return paymentList;
  }

  const selectedStatus = filterPayment.status;

  if (!selectedStatus || selectedStatus === "ALL") {
    return paymentList;
  }

  return {
    ...paymentList,
    payments: paymentList.payments?.filter((payment: any) => {
      return payment.status === selectedStatus || payment.state === selectedStatus;
    }),
  } as typeof paymentList;
}, [paymentList, filterPayment.status]);

  useEffect(() => {
    if (!currentAccount?.id || !params.currencyId) {
      return;
    }

    dispatch(clearFilterPayments());

    dispatch(
      filterPayments(currentAccount.id, {
        ...filterPayment,
        currencyId: params.currencyId,
      })
    );

    dispatch(
      fetchAllPayments(currentAccount.id, {
        currencyId: params.currencyId,
        status: "ALL",
      })
    );
  }, [dispatch, currentAccount?.id, params.currencyId]);

  if (agentLoading) {
    return <LoadingForm />;
  }

  return (
    <div>
      <PageHeader
        title={`${
          isAgent
            ? t(
                "app.main.agency.edit.payment.subAgentTitle1",
                "Sub-Agent Payment"
              )
            : t("app.main.agency.edit.payment.title1", "Agent Payment")
        } ${agentForm.fullName} 
            => ${t(
              "app.main.agency.edit.payment.title2",
              "Credit"
            )}: ${currentBalance?.creditLimit} ${
          currentBalance?.currencyResponse.isoCode
        }
             & ${t(
               "app.main.agency.edit.payment.title3",
               "Current Debt"
             )}: ${paymentList?.total} ${
          currentBalance?.currencyResponse.isoCode
        }`}
        desc={t(
          "app.main.agency.edit.payment.desc",
          "History of payment transactions"
        )}
        backButton={() => {
          dispatch(resetAgentForm());
          history.push("/agents-agencies/list");
        }}
        button={t("app.main.agency.agentsList.registerButton", "Register")}
        onClickButton={() => {
          history.push(`${url}/createPayment`);
          dispatch(toggleQuickPanel());
        }}
      />

      <AgentSearchPanel />

      <AgentPaymentTable data={filteredPaymentList} loading={loading} />
    </div>
  );
};

export default AgentPaymentGeneric;